<div class="price" *ngIf="tier">
    <strong>US{{ tier.price / 100 | currency: tier.currency }}</strong>
    <em>
        <span *ngIf="tier.billingInterval == 1"> / month</span>
        <span *ngIf="tier.billingInterval != 1"> / {{ tier.billingInterval }} months</span>
    </em>
</div>

<div class="price" *ngIf="!tier">
    <strong>US$-.--</strong>
</div>
